import ProductImageUploader from "../../../ProductImageUploader";
import { useServiceImageUpload } from "./useServiceImageUpload";
import { DeleteIcon, PlusIcon } from "../../../../../assets/svgIcons";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { useParams } from "react-router-dom";

export const ServiceImageUpload = ({ formData = {} }) => {
  const { rootFormDetails, setRootFormDetails } = formData;
  const {
    deleteImage,
    handleMultipleImageUpload,
    serviceReorderImages,
    // isLoadingReorderImages,
    isUploadingImage,
  } = useServiceImageUpload({
    rootFormDetails,
    setRootFormDetails,
  });
  const handleImagesChange = (updater) => {
    setRootFormDetails((prev) => ({
      ...prev,
      media_files:
        typeof updater === "function" ? updater(prev.media_files) : updater,
    }));
  };

  const params = useParams();

  return (
    <section
      className={`${globalStyles.cardWithBorder} w-100 align-items-center`}
      style={{ maxWidth: "300px" }}
    >
      <ProductImageUploader
        images={rootFormDetails?.media_files ?? []}
        onImagesChange={handleImagesChange}
        onUpload={handleMultipleImageUpload}
        onDeleteSaved={deleteImage}
        buttonLabel="Add Product Images"
        uploadIcon={<PlusIcon className="mr-1" />}
        deleteIcon={<DeleteIcon />}
        buttonClassNames="btn btn--outline smallBtn mx-auto mb-2"
        buttonStyle={{ maxWidth: "200px" }}
        onReorder={serviceReorderImages}
        itemType="service"
        itemId={String(params?.id)}
        isUploading={isUploadingImage}
      />
    </section>
  );
};
